import request from '@/utils/request';
// 电影资源数据
export function getMovieResource(params) {
  return request({
    url: '/products/movie/cinemas',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 影院指定出票
export function getDesignationCinema(params) {
  return request({
    url: '/products/movie-ticket/cinemas',
    method: 'get',
    params: params
  });
}
// 影院出票方
export function getMovieSuppliers(params) {
  return request({
    url: '/products/movie-ticket/suppliers',
    method: 'get',
    params: params
  });
}
// 获取城市列表
export function getCitys(params) {
  return request({
    url: '/products/movie/citys',
    method: 'get',
    params: params
  });
}
// 获取蛋糕到家城市列表
export function getCakeToDoorCitys(params) {
  return request({
    url: '/products/cake-to-door/citys',
    method: 'get',
    params: params
  });
}
// 获取城市列表
export function getStoreCitys(params) {
  return request({
    url: '/products/cake-store/citys',
    method: 'get',
    params: params
  });
}
// 获取鲜花城市列表
export function getFlowerCitys(params) {
  return request({
    url: '/products/flower/citys',
    method: 'get',
    params: params
  });
}
// 获取鲜花城市列表
export function geFlowerCitys(params) {
  return request({
    url: '/products/flower/citys',
    method: 'get',
    params: params
  });
}
// 获取城市列表
export function getZydCitys(params) {
  return request({
    url: '/products/cake-store-zyd/citys',
    method: 'get',
    params: params
  });
}
// 导出影院数据
export function exportCinemas(params) {
  return request({
    url: '/products/movie/cinemas-export',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 提交数据权限
export function updateUseDataAuth(data) {
  return request({
    url: '/user/user/add-data-auth',
    method: 'post',
    data: data
  });
}
// 获取标准礼包商品库
export function getEntityPackageGoods(params) {
  return request({
    url: '/package/goods/entity-package-goods',
    method: 'get',
    params: params
  });
}
// 商城商品库
export function getEntityMallGood(params) {
  return request({
    url: '/package/goods/entity-shop-goods',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 获取城市列表
export function getGoodsRegion(params) {
  return request({
    url: '/package/goods/goods-region',
    method: 'get',
    params: params
  });
}
// 获取蛋糕到家品牌列表
export function getCakeHomeBrands(params) {
  return request({
    url: '/products/cake-to-door/brands',
    timeout: 3 * 60 * 1000,
    method: 'get',
    params: params
  });
}
// 获取蛋糕到家商品列表
export function getCakeHomeGoods(params) {
  return request({
    url: '/products/cake-to-door/goods',
    method: 'get',
    params: params
  });
}
// 导出蛋糕到家品牌数据
export function exportCakeHomeBrands(params) {
  return request({
    url: '/products/cake-to-door/brands-export',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 导出蛋糕到店品牌数据
export function exportCakeStoreBrands(params) {
  return request({
    url: '/products/cake-store/brands-export',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 导出鲜花品牌数据
export function exportFlowerBrands(params) {
  return request({
    url: '/products/flower/brands-export',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 导出蛋糕自由兑门店数据
export function exportCakeZydStore(params) {
  return request({
    url: '/products/cake-store-zyd/stores-export',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 导出蛋糕自由兑门店数据 - 运营导出
export function zydStoresExportPhone(params) {
  return request({
    url: '/products/cake-store-zyd/stores-export-phone',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 导出蛋糕自由兑品牌数据
export function exportCakeZydBrands(params) {
  return request({
    url: '/products/cake-store-zyd/brands-export',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 导出蛋糕自由兑品牌数据-运营导出
export function exportCakeZydBrandsOperation(params) {
  return request({
    url: '/products/cake-store-zyd/brands-export-operation',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 导出蛋糕到店数据
export function exportCakeStore(params) {
  return request({
    url: '/products/cake-store/stores-export',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 导出蛋糕到店数据 - 运营导出
export function storesExportPhone(params) {
  return request({
    url: '/products/cake-store/stores-export-phone',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 导出蛋糕到店商品列表数据
export function exportCakeStoreGoods(params, type) {
  var url = '/products/cake-store/goods-export';
  if (type === 'all') {
    url = '/products/cake-store/goods-export-platform';
  }
  return request({
    url: url,
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 导出鲜花商品列表数据
export function exportFlowerGoods(params) {
  return request({
    url: '/products/flower/goods-export',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 导出鲜花SKU列表数据
export function exportFlowerSkus(params) {
  return request({
    url: '/products/flower/skus-export',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 导出蛋糕到家商品数据
export function exportCakeHomeGoods(params) {
  return request({
    url: '/products/cake-to-door/goods-export',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 导出蛋糕到家SKU列表
export function exportCakeHomeSku(params, type) {
  var url = '/products/cake-to-door/skus-export';
  if (type === 'all') {
    url = '/products/cake-to-door/skus-export-platform';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
// 获取蛋糕到家品牌列表
export function getCakeHomeBrandsList(params) {
  return request({
    url: '/products/cake-to-door/goods-brands',
    method: 'get',
    params: params,
    hideLoading: true
  });
}
// 获取蛋糕到店品牌列表
export function getCakeStoreBrandsList(params) {
  return request({
    url: '/products/cake-store/goods-brands',
    method: 'get',
    params: params,
    hideLoading: true
  });
}
// 获取鲜花品牌列表
export function getFlowerBrandsList(params) {
  return request({
    url: '/products/flower/goods-brands',
    method: 'get',
    params: params,
    hideLoading: true
  });
}
// 获取蛋糕自由兑品牌列表
export function getCakeZydBrandsList(params) {
  return request({
    url: '/products/cake-store-zyd/brands',
    method: 'get',
    params: params,
    hideLoading: true
  });
}
// 获取蛋糕自由兑编码类型下拉
export function getQrcodeTypes(params) {
  return request({
    url: '/products/cake-store-zyd/qrcode-types',
    method: 'get',
    params: params
  });
}
// 获取蛋糕到家商品列表
export function getCakeHomeSku(params) {
  return request({
    url: '/products/cake-to-door/skus',
    method: 'get',
    params: params
  });
}
// 获取蛋糕到家导出按钮权限
export function getCakeHomeAuth(params) {
  return request({
    url: '/products/cake-to-door/can-export',
    method: 'get',
    params: params
  });
}
// 获取蛋糕到店导出按钮权限
export function getCakeStoreAuth(params) {
  return request({
    url: '/products/cake-store/can-export',
    method: 'get',
    params: params
  });
}
// 获取蛋糕到店导出按钮权限
export function getFlowerAuth(params) {
  return request({
    url: '/products/flower/can-export',
    method: 'get',
    params: params
  });
}
// 获取蛋糕自由兑导出按钮权限
export function getCakeZydAuth(params) {
  return request({
    url: '/products/cake-store-zyd/can-export',
    method: 'get',
    params: params
  });
}
// 商品中心下电影资源导出权限
export function movieCanExport(params) {
  return request({
    url: '/products/movie/can-export',
    method: 'get',
    params: params
  });
}
// 获取蛋糕到家品牌列表
export function getCakeStoreBrands(params) {
  return request({
    url: '/products/cake-store/brands',
    method: 'get',
    params: params
  });
}
// 获取鲜花品牌列表
export function getCakeFlowerBrands(params) {
  return request({
    url: '/products/flower/brands',
    method: 'get',
    params: params
  });
}
// 获取蛋糕自由兑品牌列表
export function getCakeZydBrands(params) {
  return request({
    url: '/products/cake-store-zyd/brands',
    method: 'get',
    params: params
  });
}
// 获取蛋糕到家门店列表
export function getCakeStoreList(params) {
  return request({
    url: '/products/cake-store/stores',
    method: 'get',
    params: params
  });
}
// 获取蛋糕自由兑门店列表
export function getCakeZydList(params) {
  return request({
    url: '/products/cake-store-zyd/stores',
    method: 'get',
    params: params
  });
}
// 获取蛋糕到家商品列表
export function getCakeStoreGoods(params) {
  return request({
    url: '/products/cake-store/goods',
    method: 'get',
    params: params
  });
}
// 获取鲜花商品列表
export function getFlowerGoods(params) {
  return request({
    url: '/products/flower/goods',
    method: 'get',
    params: params
  });
}
// 获取鲜花SKU列表
export function getFlowerSkus(params) {
  return request({
    url: '/products/flower/skus',
    method: 'get',
    params: params
  });
}
// 获取蛋糕到家商品详情
export function getGoodsDetail(params) {
  return request({
    url: '/products/cake-store/goods-detail',
    method: 'get',
    params: params
  });
}
// 获取蛋糕到家商品详情
export function getFlowerGoodsDetail(params) {
  return request({
    url: '/products/flower/goods-detail',
    method: 'get',
    params: params
  });
}
// 电影上下架选中项
export function selectUpDownCinema(data) {
  return request({
    url: '/products/movie/select-updown-cinema',
    method: 'post',
    data: data
  });
}
// 单条电影上下架
export function upDownCinema(data) {
  return request({
    url: '/products/movie/updown-cinema',
    method: 'post',
    data: data
  });
}
// 按条件查上下架电影数量
export function selectCinemaNumber(data) {
  return request({
    url: '/products/movie/pre-condition-updown-cinema',
    method: 'post',
    data: data
  });
}
// 按条件上下架电影数据
export function conditionUpDownCinema(data) {
  return request({
    url: '/products/movie/condition-updown-cinema',
    method: 'post',
    data: data
  });
}

// 获取电影调价信息
export function getAdjustCinemaDetail(data) {
  return request({
    url: '/products/movie/adjust-cinema-detail',
    method: 'post',
    data: data
  });
}
// 单个电影调价
export function adjustCinema(data) {
  return request({
    url: '/products/movie/adjust-cinema',
    method: 'post',
    data: data
  });
}
// 选中项指定出票
export function setSelectedTicket(data) {
  return request({
    url: '/products/movie-ticket/batch-set',
    method: 'post',
    data: data
  });
}
// 条件指定出票
export function setConditionTicket(data) {
  return request({
    url: '/products/movie-ticket/condition-set',
    method: 'post',
    data: data
  });
}
// 多选电影调价
export function selectAdjustCinema(data) {
  return request({
    url: '/products/movie/select-adjust-cinema',
    method: 'post',
    data: data
  });
}
// 条件电影调价
export function conditionAdjustCinema(data) {
  return request({
    url: '/products/movie/condition-adjust-cinema',
    method: 'post',
    data: data
  });
}
// 查看条件电影数量
export function preConditionAdjustCinema(data) {
  return request({
    url: '/products/movie/pre-condition-adjust-cinema',
    method: 'post',
    data: data
  });
}
// 获取电子码品牌列表
export function getCodeBrandsList(params) {
  return request({
    url: '/package/goods/get-code-brands',
    method: 'get',
    params: params
  });
}
// 获取电子码品牌列表
export function getCodeShopList(params) {
  return request({
    url: '/package/goods/code-shop-goods',
    method: 'get',
    params: params
  });
}
// 获取影视会员列表
export function getVipCardList(params) {
  return request({
    url: '/package/goods/vip-card-goods',
    method: 'get',
    params: params
  });
}
// 获取影视会员品牌列表
export function getVipCardBrandList(params) {
  return request({
    url: '/package/goods/get-vip-card-brands',
    method: 'get',
    params: params
  });
}
// 获取影视会员分类列表
export function getVipCardCatList(params) {
  return request({
    url: '/package/category/vip-card-data',
    method: 'get',
    params: params
  });
}
// 批量下架
export function postGoodsChangeDown(data) {
  return request({
    url: '/package/goods/channel-goods-change-down',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 批量上架
export function postGoodsChangeUp(data) {
  return request({
    url: '/package/goods/channel-goods-change-up',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 影视会员导出
export function exportVipCardGoods(data) {
  return request({
    url: '/package/goods/vip-card-goods-export',
    method: 'post',
    data: data
  });
}
// 获取景区列表
export function getScenicList(params) {
  return request({
    url: '/package/goods/lmm-product-index',
    method: 'get',
    params: params
  });
}
// 获取景区列表-携程
export function getXcScenicList(params) {
  return request({
    url: '/package/goods/lmm-product-index-xc',
    method: 'get',
    params: params
  });
}
// 获取景区列表
export function getScenicType(params) {
  return request({
    url: '/package/goods/lmm-themes',
    method: 'get',
    params: params
  });
}
// 获取景区列表-携程
export function getXcScenicType(params) {
  return request({
    url: '/package/goods/lmm-themes-xc',
    method: 'get',
    params: params
  });
}
// 获取景区评级
export function getScenicLevel(params) {
  return request({
    url: '/package/goods/lmm-place-level',
    method: 'get',
    params: params
  });
}
// 获取景区评级-携程
export function getXcScenicLevel(params) {
  return request({
    url: '/package/goods/lmm-place-level-xc',
    method: 'get',
    params: params
  });
}
// 获取景区门票列表
export function getScenicTicketsList(params) {
  return request({
    url: '/package/goods/lmm-goods-index',
    method: 'get',
    params: params
  });
}
// 获取景区门票列表-景区门票新
export function getXcScenicTicketsList(params) {
  return request({
    url: '/package/goods/lmm-goods-index-xc',
    method: 'get',
    params: params
  });
}
// 获取景区票种
export function getTicketType(params) {
  return request({
    url: '/package/goods/lmm-goods-ticket-type',
    method: 'get',
    params: params
  });
}
// 获取景区票种-携程
export function getXcTicketType(params) {
  return request({
    url: '/package/goods/lmm-goods-ticket-type-xc',
    method: 'get',
    params: params
  });
}
// 获取门票说明
export function getTicketNotice(params) {
  return request({
    url: '/package/goods/lmm-goods-notice',
    method: 'get',
    params: params
  });
}
// 获取门票说明-携程
export function getXcTicketNotice(params) {
  return request({
    url: '/package/goods/lmm-goods-notice-xc',
    method: 'get',
    params: params
  });
}
// 获取演出列表
export function getPerformList(params) {
  return request({
    url: '/products/dudu-yanchu/goods',
    method: 'get',
    params: params
  });
}
// 获取演出城市列表
export function getPerformCity(params) {
  return request({
    url: '/products/dudu-yanchu/city',
    method: 'get',
    params: params
  });
}
// 获取演出类型列表
export function getPerformType(params) {
  return request({
    url: '/products/dudu-yanchu/class',
    method: 'get',
    params: params
  });
}
// 获取演出门票列表
export function getPerformTicketsList(params) {
  return request({
    url: '/products/dudu-yanchu/price-list',
    method: 'get',
    params: params
  });
}
// 批量排序
export function postGoodsSortOrder(data) {
  return request({
    url: '/package/goods/channel-goods-change-sort-order',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 蛋糕到家商品列表排序
export function cakeHomeGoodsSelectSort(data) {
  return request({
    url: '/products/cake-to-door/select-sort',
    method: 'post',
    data: data
  });
}
// 蛋糕到家商品列表排序
export function cakeHomeGoodsConditionSort(data) {
  return request({
    url: '/products/cake-to-door/condition-sort',
    method: 'post',
    data: data
  });
}
// 批量排序
export function postGoodsSortOrderVip(data) {
  return request({
    url: '/package/goods/channel-goods-change-sort-order-vip-card',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 获取近期票价
export function getLmmGoodsPrice(params) {
  return request({
    url: '/package/goods/lmm-goods-price',
    method: 'get',
    params: params
  });
}
// 获取操作日志分类
export function getGoodsLogCategory(params) {
  return request({
    url: '/package/goods/get-category',
    method: 'get',
    params: params
  });
}
// 获取商城商品操作日志
export function getShopGoodsLog(params) {
  return request({
    url: '/package/goods/get-shop-goods-log',
    method: 'get',
    params: params
  });
}
// 获取商城商品操作日志
export function getPackageGoodsLog(params) {
  return request({
    url: '/package/goods/get-package-goods-log',
    method: 'get',
    params: params
  });
}
// 获取近期票价-携程
export function getXcLmmGoodsPrice(params) {
  return request({
    url: '/package/goods/lmm-goods-price-xc',
    method: 'get',
    params: params
  });
}

/**
 * 图书资源 - 列表
 * @param {*} params
 * @returns
 */
export function getBooksGoods(params) {
  return request({
    url: '/package/goods/books-goods',
    method: 'get',
    params: params
  });
}

/**
 * 图书资源 - 获取分类列表
 * @param {*} params
 * @returns
 */
export function getBooksCategory(params) {
  return request({
    url: '/package/category/books-category',
    method: 'get',
    params: params
  });
}

/**
 * 图书资源 - 获取品牌列表
 * @param {*} params
 * @returns
 */
export function getBooksBrands(params) {
  return request({
    url: '/package/goods/books-brands',
    method: 'get',
    params: params
  });
}
// 演出调价
export function getDuduOverallRule(params) {
  return request({
    url: '/products/dudu-yanchu/get-overall-rule',
    method: 'get',
    params: params
  });
}
// 保存演出调价
export function postDuduOverallRule(data) {
  return request({
    url: '/products/dudu-yanchu/save-overall-rule',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 选中的规则影院列表
export function getCinemaList(data) {
  return request({
    url: '/products/channel-cinema-adjust/cinemas',
    method: 'post',
    data: data
  });
}
// 选中的规则影院列表
export function getCinemaRules(data) {
  return request({
    url: '/products/channel-cinema-adjust/rules',
    method: 'post',
    data: data
  });
}
// 获取电影调价规则类型
export function getRuleTypes(params) {
  var controller = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cinema';
  return request({
    url: "/products/channel-".concat(controller, "-adjust/rule-types"),
    method: 'get',
    params: params
  });
}
// 按条件查询所有的影院列表编码
export function getCinemaConditionCode(params) {
  return request({
    url: '/products/channel-cinema-adjust/condition-cinema-code',
    method: 'get',
    params: params
  });
}
export function getCustomerList(data) {
  return request({
    url: '/products/channel-cinema-adjust/customer',
    method: 'post',
    data: data
  });
}
// 客户电影调价
export function setCinemaAdjust(data) {
  return request({
    url: '/products/channel-cinema-adjust/set-rule',
    method: 'post',
    data: data
  });
}
// 删除影院调价
export function delCinemaRule(data) {
  return request({
    url: '/products/channel-cinema-adjust/del-rule',
    method: 'post',
    data: data
  });
}
// 获取已设置的规则详情数据
export function getEditCinemaRule(params) {
  return request({
    url: '/products/channel-cinema-adjust/rule',
    method: 'get',
    params: params
  });
}
// 获取已设置的影院规则选择的客户
export function getEditCinemaRuleCustom(params) {
  return request({
    url: '/products/channel-cinema-adjust/rule-companys',
    method: 'get',
    params: params
  });
}
// 获取已设置的影院规则选择的影院
export function getEditCinemaRuleCinema(params) {
  return request({
    url: '/products/channel-cinema-adjust/rule-cinemas',
    method: 'get',
    params: params
  });
}
// 恢复默认排序
export function changeDefaultSort(data) {
  return request({
    url: '/package/goods/channel-goods-change-sort-order-init',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 商城商品库 导出
export function exportProductGoods(data) {
  return request({
    url: '/products/goods/goods-export',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 标准礼包商品库 导出
export function exportPackageGoods(data) {
  return request({
    url: '/products/goods/goods-export-package',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 获取影院调价日志
export function getCinemaRuleLog(params) {
  var controller = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cinema';
  return request({
    url: "/products/channel-".concat(controller, "-adjust/rule-logs"),
    method: 'get',
    params: params
  });
}
// 获取客户更新日志
export function getCompanyUpdateLogs(params) {
  var controller = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cinema';
  return request({
    url: "/products/channel-".concat(controller, "-adjust/company-logs"),
    method: 'get',
    params: params
  });
}
// 获取影院更新日志
export function getCinemaUpdateLogs(params) {
  return request({
    url: '/products/channel-cinema-adjust/cinema-logs',
    method: 'get',
    params: params
  });
}

// 获取蛋糕到店客户范围
export function getCakestoreCustomerList(data) {
  var controller = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cakestore';
  return request({
    url: "/products/channel-".concat(controller, "-adjust/customer"),
    method: 'post',
    data: data
  });
}
// 选中的蛋糕到店规则列表
export function getCakestoreRules(data) {
  var controller = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cakestore';
  return request({
    url: "/products/channel-".concat(controller, "-adjust/rules"),
    method: 'post',
    data: data
  });
}
// 获取到店调价规则类型
export function getCakestoreRuleTypes(params) {
  var controller = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cakestore';
  return request({
    url: "/products/channel-".concat(controller, "-adjust/rule-types"),
    method: 'get',
    params: params
  });
}
// 获取到店调价基数
export function getCakestoreMoneyTypes(params) {
  var controller = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cakestore';
  return request({
    url: "/products/channel-".concat(controller, "-adjust/money-types"),
    method: 'get',
    params: params
  });
}
// 蛋糕到店设置调价规则
export function setCakestoreAdjust(data) {
  var controller = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cakestore';
  return request({
    url: "/products/channel-".concat(controller, "-adjust/set-rule"),
    method: 'post',
    data: data
  });
}
// 蛋糕到店删除调价
export function delCakestoreRule(data) {
  var controller = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cakestore';
  return request({
    url: "/products/channel-".concat(controller, "-adjust/del-rule"),
    method: 'post',
    data: data
  });
}
// 获取客户更新日志
export function getStoreCompanyUpdateLogs(params) {
  return request({
    url: '/products/channel-cakestore-adjust/company-logs',
    method: 'get',
    params: params
  });
}
// 获取已设置的到店规则选择的客户
export function getEditCakestoreRuleCustom(params) {
  var controller = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cakestore';
  return request({
    url: "/products/channel-".concat(controller, "-adjust/rule-companys"),
    method: 'get',
    params: params
  });
}
// 获取已设置的景区门票选择的客户
export function getEditTicketRuleCustom(params) {
  return request({
    url: '/products/channel-entrance-ticket-adjust/rule-companys',
    method: 'get',
    params: params
  });
}
// 获取已设置的规则详情数据
export function getEditCakestoreRule(params) {
  var controller = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cakestore';
  return request({
    url: "/products/channel-".concat(controller, "-adjust/rule"),
    method: 'get',
    params: params
  });
}

// 获取蛋糕到家客户范围
export function getCakehomeCustomerList(data) {
  return request({
    url: '/products/channel-caketodoor-adjust/customer',
    method: 'post',
    data: data
  });
}
// 选中的蛋糕到店规则列表
export function getCakehomeRules(data) {
  return request({
    url: '/products/channel-caketodoor-adjust/rules',
    method: 'post',
    data: data
  });
}
// 获取到店调价规则类型
export function getCakehomeRuleTypes(params) {
  return request({
    url: '/products/channel-caketodoor-adjust/rule-types',
    method: 'get',
    params: params
  });
}
// 获取到店调价基数
export function getCakehomeMoneyTypes(params) {
  return request({
    url: '/products/channel-caketodoor-adjust/money-types',
    method: 'get',
    params: params
  });
}
// 蛋糕到店设置调价规则
export function setCakehomeAdjust(data) {
  return request({
    url: '/products/channel-caketodoor-adjust/set-rule',
    method: 'post',
    data: data
  });
}
// 蛋糕到店删除调价
export function delCakehomeRule(data) {
  return request({
    url: '/products/channel-caketodoor-adjust/del-rule',
    method: 'post',
    data: data
  });
}
// 获取客户更新日志
export function getHomeCompanyUpdateLogs(params) {
  return request({
    url: '/products/channel-caketodoor-adjust/company-logs',
    method: 'get',
    params: params
  });
}
// 获取已设置的到店规则选择的客户
export function getEditCakehomeRuleCustom(params) {
  return request({
    url: '/products/channel-caketodoor-adjust/rule-companys',
    method: 'get',
    params: params
  });
}
// 获取已设置的规则详情数据
export function getEditCakehomeRule(params) {
  return request({
    url: '/products/channel-caketodoor-adjust/rule',
    method: 'get',
    params: params
  });
}

// 选中的鲜花规则列表
export function getFlowerRules(data) {
  return request({
    url: '/products/channel-flower-adjust/rules',
    method: 'post',
    data: data
  });
}
// 获取鲜花调价规则类型
export function getFlowerRuleTypes(params) {
  return request({
    url: '/products/channel-flower-adjust/rule-types',
    method: 'get',
    params: params
  });
}
// 鲜花删除调价
export function delFlowerRule(data) {
  return request({
    url: '/products/channel-flower-adjust/del-rule',
    method: 'post',
    data: data
  });
}
// 鲜花设置调价规则
export function setFlowerAdjust(data) {
  return request({
    url: '/products/channel-flower-adjust/set-rule',
    method: 'post',
    data: data
  });
}
// 获取鲜花客户范围
export function getFlowerCustomerList(data) {
  return request({
    url: '/products/channel-flower-adjust/customer',
    method: 'post',
    data: data
  });
}
// 获取鲜花调价基数
export function getFlowerMoneyTypes(params) {
  return request({
    url: '/products/channel-flower-adjust/money-types',
    method: 'get',
    params: params
  });
}
// 获取已设置的规则详情数据
export function getEditFlowerRule(params) {
  return request({
    url: '/products/channel-flower-adjust/rule',
    method: 'get',
    params: params
  });
}
// 获取已设置的鲜花规则选择的客户
export function getEditFlowerRuleCustom(params) {
  return request({
    url: '/products/channel-flower-adjust/rule-companys',
    method: 'get',
    params: params
  });
}
// 电子码限购
export function codeQuotaByChecked(data) {
  return request({
    url: '/package/goods/save-total-quota',
    method: 'post',
    data: data
  });
}
// 获取在线点单品牌列表
export function getOnlineBrandsList(params) {
  return request({
    url: '/products/online-foods/brands',
    method: 'get',
    params: params,
    hideLoading: true
  });
}
// 导出在线点单品牌数据
export function exportOnlineBrands(params) {
  return request({
    url: '/products/online-foods/brands-export',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 获取在线点单城市列表
export function getOnlineCitys(params) {
  return request({
    url: '/products/online-foods/citys',
    method: 'get',
    params: params
  });
}
// 获取在线点单门店列表
export function getOnlineStoreList(params) {
  return request({
    url: '/products/online-foods/restaurant-list',
    method: 'get',
    params: params
  });
}
// 导出在线点单门店数据
export function exportOnlineStore(params) {
  return request({
    url: '/products/online-foods/restaurant-export',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}

// 导出在线点单门店数据 - 运营导出
export function restaurantExportPhone(params) {
  return request({
    url: '/products/online-foods/restaurant-export-phone',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}

// 获取在线点单-商品列表
export function getOnlineProductList(params) {
  return request({
    url: '/products/online-foods/product-list',
    method: 'get',
    params: params
  });
}
// 获取在线点单品牌-搜索项
export function getOnlineBrandSearch(params) {
  return request({
    url: '/products/online-foods/brand-search',
    method: 'get',
    params: params
  });
}
// 导出在线点单商品列表
export function exportOnlineProduct(params) {
  return request({
    url: '/products/online-foods/product-export',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 演出类型（新）
export function getNewPerformType(params) {
  return request({
    url: '/products/zy-yanchu/class',
    method: 'get',
    params: params
  });
}
// 获取演出城市列表 （新）
export function getNewPerformCity(params) {
  return request({
    url: '/products/zy-yanchu/city',
    method: 'get',
    params: params
  });
}
// 获取演出列表 （新）
export function getNewPerformList(params) {
  return request({
    url: '/products/zy-yanchu/goods',
    method: 'get',
    params: params
  });
}
// 演出调价 （新）
export function getNewOverallRule(params) {
  return request({
    url: '/products/zy-yanchu/get-overall-rule',
    method: 'get',
    params: params
  });
}
// 保存演出调价 （新）
export function postNewOverallRule(data) {
  return request({
    url: '/products/zy-yanchu/save-overall-rule',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 获取景区票种 （新）
export function getNewTicketType(params) {
  return request({
    url: '/package/goods/lmm-goods-ticket-type',
    method: 'get',
    params: params
  });
}
// 获取演出门票列表 （新）
export function getNewPerformTicketsList(params) {
  return request({
    url: '/products/zy-yanchu/price-list',
    method: 'get',
    params: params
  });
}
// 鲜花选中排序
export function flowerGoodsSelectSort(data) {
  return request({
    url: '/products/flower/select-sort',
    method: 'post',
    data: data
  });
}
// 鲜花条件排序
export function flowerGoodsConditionSort(data) {
  return request({
    url: '/products/flower/condition-sort',
    method: 'post',
    data: data
  });
}
// 鲜花单独排序
export function flowerGoodsSingleSort(data) {
  return request({
    url: '/products/flower/single-sort',
    method: 'post',
    data: data
  });
}
// 蛋糕到家独排序
export function cakeHomeGoodsSingleSort(data) {
  return request({
    url: '/products/cake-to-door/single-sort',
    method: 'post',
    data: data
  });
}
// 蛋糕到家品牌 选中排序
export function cakeHomeBrandSelectSort(data) {
  return request({
    url: '/products/cake-to-door/brand-select-sort',
    method: 'post',
    data: data
  });
}
// 蛋糕到家品牌 条件排序
export function cakeHomeBrandConditionSort(data) {
  return request({
    url: '/products/cake-to-door/brand-condition-sort',
    method: 'post',
    data: data
  });
}
// 蛋糕到家品牌 独排序
export function cakeHomeBrandSingleSort(data) {
  return request({
    url: '/products/cake-to-door/brand-single-sort',
    method: 'post',
    data: data
  });
}
// 蛋糕到家品牌 条件排序
export function packageGoodsSetPromotion(data) {
  return request({
    url: '/package/goods/set-promotion',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 蛋糕到店品牌 条件排序
export function cakeStoreBrandConditionSort(data) {
  return request({
    url: '/products/cake-store/brand-condition-sort',
    method: 'post',
    data: data
  });
}
// 蛋糕到店品牌 独排序
export function cakeStoreBrandSingleSort(data) {
  return request({
    url: '/products/cake-store/brand-single-sort',
    method: 'post',
    data: data
  });
}
// 蛋糕到店品牌 选中排序
export function packageStoreGoodsSetPromotion(data) {
  return request({
    url: '/products/cake-store/brand-select-sort',
    method: 'post',
    data: data
  });
}
// 商品中心恢复默认 选中
export function channelGoodsCheckedRestore(data) {
  return request({
    url: '/malldecoration/channel-goods/checked-restore',
    method: 'post',
    data: data
  });
}
// 商品中心恢复默认 按条件
export function channelGoodsConditionRestore(data) {
  return request({
    url: '/malldecoration/channel-goods/condition-restore',
    method: 'post',
    data: data
  });
}
// 商品中心调价 选中
export function channelGoodsCheckedAdjust(data) {
  return request({
    url: '/malldecoration/channel-goods/checked-adjust',
    method: 'post',
    data: data
  });
}
// 商品中心调价 条件
export function channelGoodsConditionAdjust(data) {
  return request({
    url: '/malldecoration/channel-goods/condition-adjust',
    method: 'post',
    data: data
  });
}
// 商品中心调价 单独
export function channelGoodsOneAdjust(data) {
  return request({
    url: '/malldecoration/channel-goods/hand-adjust',
    method: 'post',
    data: data
  });
}
// 景区导出
export function exportlmmProduct(params) {
  return request({
    url: '/package/goods/lmm-product-index-xc-export',
    method: 'get',
    params: params
  });
}
// 景区门票
export function exportlmmGoods(params) {
  return request({
    url: '/package/goods/lmm-goods-index-xc-export',
    method: 'get',
    params: params
  });
}
// 商品中心 - 在线点单 - 上下架
export function changeBrandShelf(data) {
  return request({
    url: '/products/online-foods/change-brand-shelf',
    method: 'post',
    data: data
  });
}

/**
 * 商品中心 - 在线点单 - 品牌列表 获取设置售价比例数据
 * @param {*} params
 * @returns
 */
export function getBrandRate(params) {
  return request({
    url: '/products/online-foods/get-channel-brand-price-rate',
    method: 'get',
    params: params
  });
}
/**
 * 商品中心 - 在线点单 - 品牌列表 设置售价比例数据
 * @param {*} data
 * @param {*} method
 * @returns
 */
export function saveBrandRate(data) {
  return request({
    url: '/products/online-foods/save-channel-brand-price-rate',
    method: 'post',
    data: data
  });
}
// 自由兑兑换列表
export function getChannelCakeZydList(params) {
  return request({
    url: '/products/channel-zyd-adjust/rules',
    method: 'get',
    params: params
  });
}
// 自由兑兑换列表删除
export function delZydRule(data) {
  return request({
    url: '/products/channel-zyd-adjust/del-rule',
    method: 'post',
    data: data
  });
}
// 自由兑待选客户列表
export function getZydCustomerList(data) {
  return request({
    url: '/products/channel-zyd-adjust/customer',
    method: 'post',
    data: data
  });
}
// 自由兑已选客户列表
export function getZydCustomerCompanysList(params) {
  return request({
    url: '/products/channel-zyd-adjust/rule-companys',
    method: 'get',
    params: params
  });
}
// 自由兑待品牌选列表
export function getZydProductList(data) {
  return request({
    url: '/products/channel-zyd-adjust/zyds',
    method: 'post',
    data: data
  });
}
// 自由兑品牌已选列表
export function getZydProductSelectList(params) {
  return request({
    url: '/products/channel-zyd-adjust/rule-zyds',
    method: 'get',
    params: params
  });
}
// 自由兑品牌提交折扣规则
export function saveSetZydRule(data) {
  return request({
    url: '/products/channel-zyd-adjust/set-rule',
    method: 'post',
    data: data
  });
}
// 自由兑折扣详情
export function getEditZyAdjustRule(params) {
  return request({
    url: '/products/channel-zyd-adjust/rule',
    method: 'get',
    params: params
  });
}

// 演出资源新
// 选中的演出资源规则列表
export function getNewPerformRules(data) {
  return request({
    url: '/products/channel-yanchu-adjust/rules',
    method: 'post',
    data: data
  });
}
// 获取演出资源调价规则类型
export function getNewPerformRuleTypes(params) {
  return request({
    url: '/products/channel-yanchu-adjust/rule-types',
    method: 'get',
    params: params
  });
}
// 演出资源设置调价规则
export function setNewPerformAdjust(data) {
  return request({
    url: '/products/channel-yanchu-adjust/set-rule',
    method: 'post',
    data: data
  });
}
// 演出资源删除调价
export function delNewPerformRule(data) {
  return request({
    url: '/products/channel-yanchu-adjust/del-rule',
    method: 'post',
    data: data
  });
}
// 获取蛋糕到店客户范围
export function getNewPerformCustomerList(data) {
  return request({
    url: '/products/channel-yanchu-adjust/customer',
    method: 'post',
    data: data
  });
}
// 获取到店调价基数
export function getNewPerformMoneyTypes(params) {
  return request({
    url: '/products/channel-yanchu-adjust/money-types',
    method: 'get',
    params: params
  });
}
// 获取已设置的规则详情数据
export function getEditNewPerformRule(params) {
  return request({
    url: '/products/channel-yanchu-adjust/rule',
    method: 'get',
    params: params
  });
}
// 获取已设置的到店规则选择的客户
export function getEditNewPerformRuleCustom(params) {
  return request({
    url: '/products/channel-yanchu-adjust/rule-company',
    method: 'get',
    params: params
  });
}

// 获取客户更新日志
export function getnYanchuCompanyUpdateLogs(params) {
  return request({
    url: '/products/channel-yanchu-adjust/company-logs',
    method: 'get',
    params: params
  });
}
// 获取演出更新日志
export function getYanchuUpdateLogs(params) {
  return request({
    url: '/products/channel-yanchu-adjust/cinema-logs',
    method: 'get',
    params: params
  });
}
// 获取演出调价日志
export function getYanchuRuleLog(params) {
  return request({
    url: '/products/channel-yanchu-adjust/rule-logs',
    method: 'get',
    params: params
  });
}
// 在线点单折扣列表
export function getChannelOnlineFoodsList(params) {
  return request({
    url: '/products/channel-online-foods-adjust/rules',
    method: 'get',
    params: params
  });
}
// 在线点单折扣列表 - 规则
export function getOnlineFoodsRuleTypes(params) {
  return request({
    url: '/products/channel-online-foods-adjust/rule-types',
    method: 'get',
    params: params
  });
}
// 在线点单折扣列表
export function delOnlineFoodsRule(data) {
  return request({
    url: '/products/channel-online-foods-adjust/del-rule',
    method: 'post',
    data: data
  });
}
// 在线点单折扣获取城市列表
export function getOnlineFoodsCitys(params) {
  return request({
    url: '/products/online-foods/citys',
    method: 'get',
    params: params
  });
}
// 在线点单折扣待选客户列表
export function getOnlineFoodsCustomerList(data) {
  return request({
    url: '/products/channel-online-foods-adjust/customer',
    method: 'post',
    data: data
  });
}
// 在线点单折扣已选客户列表
export function getOnlineFoodsCustomerCompanysList(params) {
  return request({
    url: '/products/channel-online-foods-adjust/rule-companys',
    method: 'get',
    params: params
  });
}
// 在线点单折扣待品待牌选列表
export function getOnlineFoodsProductList(data) {
  return request({
    url: 'products/channel-online-foods-adjust/get-online-foods-brand',
    method: 'post',
    data: data
  });
}
// 在线点单折扣品牌已选列表
export function getOnlineFoodsProductSelectList(params) {
  return request({
    url: '/products/channel-online-foods-adjust/rule-brand',
    method: 'get',
    params: params
  });
}
// 自由兑品牌提交折扣规则
export function saveSetOnlineFoodsRule(data) {
  return request({
    url: '/products/channel-online-foods-adjust/set-rule',
    method: 'post',
    data: data
  });
}
// 自由兑折扣详情
export function getEditOnlineFoodsAdjustRule(params) {
  return request({
    url: '/products/channel-online-foods-adjust/rule',
    method: 'get',
    params: params
  });
}
// 自由兑日志
export function getZydLog(params) {
  return request({
    url: '/products/channel-zyd-adjust/rule-logs',
    method: 'get',
    params: params
  });
}
// 自由兑日志 规则类型
export function getZydRuleTypes(params) {
  return request({
    url: "/products/channel-zyd-adjust/rule-types",
    method: 'get',
    params: params
  });
}
// 自由兑日志 更新前后日志
export function getZydUpdateLogs(params) {
  return request({
    url: '/products/channel-zyd-adjust/zyd-logs',
    method: 'get',
    params: params
  });
}
//  自由兑日志 获取客户更新日志
export function getZydCompanyUpdateLogs(params) {
  return request({
    url: "/products/channel-zyd-adjust/company-logs",
    method: 'get',
    params: params
  });
}
// 在线点单 规则类型
export function getOnlineRuleTypes(params) {
  return request({
    url: "/products/channel-online-foods-adjust/rule-types",
    method: 'get',
    params: params
  });
}
// 在线点单日志
export function getOnlineLog(params) {
  return request({
    url: '/products/channel-online-foods-adjust/rule-logs',
    method: 'get',
    params: params
  });
}
// 在线点单日志 获取客户更新日志
export function getOnlineCompanyUpdateLogs(params) {
  return request({
    url: "/products/channel-online-foods-adjust/company-logs",
    method: 'get',
    params: params
  });
}
// 在线点单日志 品牌更新前后日志
export function getBrandUpdateLogs(params) {
  return request({
    url: '/products/channel-online-foods-adjust/brand-logs',
    method: 'get',
    params: params
  });
}
// 演出列表 导出
export function performExport(params) {
  return request({
    url: '/products/zy-yanchu/export',
    method: 'get',
    params: params
  });
}

/**
 * 在线点单 操作日志列表
 * @param {*} params
 * @returns
 */
export function getLog(params) {
  return request({
    url: '/products/online-foods/get-online-foods-operate-log',
    method: 'get',
    params: params
  });
}
// 蛋糕到店商品列表 选中设置取消限购
export function cakeStoreCheckedLimit(data) {
  return request({
    url: '/products/cake-store/goods-select-limit',
    method: 'post',
    data: data
  });
}
// 蛋糕到店商品列表 按条件设置取消限购
export function cakeStoreConditionLimit(data) {
  return request({
    url: 'products/cake-store/goods-condition-limit',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 标准礼包商品库 设置特价
export function standardPackageGoodsSetPromotion(data) {
  return request({
    url: '/package/goods/set-promotion-package',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 导出全部影院数据
export function exportAllCinema(params) {
  return request({
    url: '/products/movie/all-cinemas-export',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 权益直冲调价
export function handAdjustVip(params) {
  return request({
    url: '/malldecoration/channel-goods/hand-adjust-vip',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}

// 获取调价折扣预警规则
export function handChannelWarningRestrictions(params) {
  return request({
    url: '/user/channel/get-channel-warning-restrictions',
    method: 'get',
    params: params
  });
}
// 蛋糕到店品牌列表
export function getCakeSearchStoreBrands(params) {
  return request({
    url: '/products/cake-store/categorys',
    method: 'get',
    params: params
  });
}
// 获取商品配送模板
export function getShopGoodsShipping(params) {
  return request({
    url: '/package/goods/get-shop-goods-shipping',
    method: 'get',
    params: params
  });
}

// 获取商品礼包配送模板
export function getPackageGoodsShipping(params) {
  return request({
    url: '/package/goods/get-package-goods-shipping',
    method: 'get',
    params: params
  });
}